import { extractUndefined } from '@/packages/utils/extractUndefined';

import { type TCianApiSiteV1GetUserDataByRequestResponse_1 } from '@/repositories/generated/shared/monolith-python/cian-api/site/v1/get-user-data-by-request';

export function dataFromCianApiSiteV1GetUserDataByRequestSelector(
  state: TCianApiSiteV1GetUserDataByRequestResponse_1,
): TCianApiSiteV1GetUserDataByRequestResponse_1['data'] {
  return state.data;
}

export function userCianApiSiteV1GetUserDataByRequestSelector(
  state: TCianApiSiteV1GetUserDataByRequestResponse_1,
): TCianApiSiteV1GetUserDataByRequestResponse_1['data']['user'] | null {
  return extractUndefined(dataFromCianApiSiteV1GetUserDataByRequestSelector(state).user);
}

export function userIsAuthenticatedSelector(state: TCianApiSiteV1GetUserDataByRequestResponse_1): boolean {
  return !!userCianApiSiteV1GetUserDataByRequestSelector(state)?.isAuthenticated;
}
